module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Vertical-c0de472baebb048a9d9f0c6b6fa5d549.svg";